<div class="min-h-screen flex flex-col dark:bg-gray-950">
  <!-- Banner superior mobile - Solo visible en pantallas pequeñas -->
  <div
    class="lg:hidden p-6 shadow-lg"
    style="background: linear-gradient(to right, #fc415a, #55dcce)"
  >
    <div class="flex items-center justify-center gap-3">
      <img src="assets/SVG/sdi_logo_white.svg" alt="SDi Logo" class="h-8" />
    </div>
  </div>

  <!-- Contenedor principal para panel izquierdo y derecho -->
  <div class="flex flex-1">
    <!-- Panel izquierdo - Hero con imagen de fondo -->
    <div class="hidden lg:flex lg:w-1/2 relative overflow-hidden" style="background-color: #1a1a2e">
      <!-- Imagen de fondo -->
      <div
        class="absolute inset-0 bg-cover bg-center opacity-30"
        style="background-image: url('/images/background-login.png')"
      ></div>

      <!-- Overlay más suave -->
      <div
        class="absolute inset-0"
        style="
          background: linear-gradient(
            135deg,
            rgba(252, 65, 90, 0.4) 0%,
            rgba(85, 220, 206, 0.2) 100%
          );
        "
      ></div>

      <div class="relative z-10 flex flex-col justify-between p-12 text-white w-full">
        <!-- Header -->
        <div>
          <div class="flex items-center gap-2 mb-8">
            <img src="assets/SVG/sdi_logo_white.svg" alt="SDi Logo" class="h-16" />
          </div>

          <h1 class="text-5xl font-bold mb-6 leading-tight">
            Desbloquea el crecimiento<br />a través de alianzas<br />estratégicas.
          </h1>

          <p class="text-lg text-white/90 max-w-md">
            Gestiona tus oportunidades de negocio, rastrea comisiones en tiempo real y escala tu red
            con nuestro ecosistema integral.
          </p>
        </div>

        <!-- Stats -->
        <div class="flex gap-12">
          <div>
            <div class="text-4xl font-bold mb-1">500+</div>
            <div class="text-white/80 text-sm">Partners Activos</div>
          </div>
          <div>
            <div class="text-4xl font-bold mb-1">12%</div>
            <div class="text-white/80 text-sm">Tasa de Crecimiento</div>
          </div>
        </div>
      </div>
    </div>

    <!-- Panel derecho - Form -->
    <div class="flex-1 flex items-center justify-center p-8 bg-white dark:bg-gray-900">
      <div class="w-full max-w-md">
        @if (isProcessingMicrosoftLogin) {
          <div class="loading-state">
            <div class="loading-spinner" role="img" aria-hidden="true"></div>
            <p
              class="text-[15px] text-gray-700 dark:text-gray-300 text-center"
              role="status"
              aria-live="polite"
            >
              Procesando inicio de sesión con Microsoft...
            </p>
          </div>
        } @else {
          <div class="mb-8">
            <h2 class="text-3xl font-bold text-gray-900 dark:text-white mb-2">Iniciar sesión</h2>
            <p class="text-gray-600 dark:text-gray-400 text-sm">
              Introduce tus credenciales para acceder a tu panel.
            </p>
          </div>
          <form [formGroup]="form" (ngSubmit)="submit()" class="space-y-6">
            <div>
              <label
                for="email"
                class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2"
                >Correo electrónico</label
              >
              <input
                id="email"
                type="email"
                formControlName="email"
                class="app-input w-full"
                placeholder="nombre@empresa.com"
              />
              @if (form.controls.email.touched && form.controls.email.invalid) {
                <p class="text-sm text-red-600 dark:text-red-400 mt-2">
                  Por favor, introduce un email válido.
                </p>
              }
            </div>

            <div>
              <div class="flex items-center justify-between mb-2">
                <label
                  for="password"
                  class="block text-sm font-medium text-gray-700 dark:text-gray-300"
                  >Contraseña</label
                >
                <a
                  href="#"
                  (click)="openForgot(); $event.preventDefault()"
                  class="text-sm hover:underline"
                  style="color: #fc415a"
                  >¿Olvidaste tu contraseña?</a
                >
              </div>
              <div class="relative">
                <input
                  id="password"
                  [type]="passwordVisible ? 'text' : 'password'"
                  formControlName="password"
                  class="app-input w-full"
                  placeholder="········"
                />
                <button
                  type="button"
                  class="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 dark:text-gray-500 hover:text-gray-600 dark:hover:text-gray-300"
                  (click)="togglePasswordVisibility()"
                  aria-pressed="{{ passwordVisible }}"
                >
                  <fa-icon [icon]="passwordVisible ? faEyeSlash : faEye"></fa-icon>
                  <span class="sr-only">{{
                    passwordVisible ? 'Ocultar contraseña' : 'Mostrar contraseña'
                  }}</span>
                </button>
              </div>
              @if (form.controls.password.touched && form.controls.password.invalid) {
                <p class="text-sm text-red-600 dark:text-red-400 mt-2">
                  La contraseña es obligatoria.
                </p>
              }
            </div>

            <!-- <div class="flex items-center">
            <input
              id="remember"
              type="checkbox"
              class="w-4 h-4 rounded border-gray-300 dark:border-gray-700 bg-white dark:bg-gray-800 text-blue-600 focus:ring-blue-500 dark:focus:ring-blue-600 focus:ring-offset-white dark:focus:ring-offset-gray-900"
            />
            <label for="remember" class="ml-2 text-sm text-gray-700 dark:text-gray-300"
              >Recuérdame por 30 días</label
            >
          </div> -->

            @if (errorMessage) {
              <div
                class="rounded-lg bg-red-50 dark:bg-red-500/10 border border-red-200 dark:border-red-500/50 p-3 text-sm text-red-700 dark:text-red-400"
              >
                {{ errorMessage }}
              </div>
            }

            <button
              type="submit"
              [disabled]="isLoading || isProcessingMicrosoftLogin || isMicrosoftLoginLoading"
              class="app-btn app-btn--primary app-btn--center w-full"
            >
              @if (!isLoading) {
                <span>Iniciar sesión</span>
              } @else {
                <span>Iniciando sesión...</span>
              }
            </button>

            <!-- Separador -->
            <div class="relative">
              <div class="absolute inset-0 flex items-center">
                <div class="w-full border-t border-gray-300 dark:border-gray-700"></div>
              </div>
              <div class="relative flex justify-center text-sm">
                <span class="px-2 bg-white dark:bg-gray-900 text-gray-500 dark:text-gray-400"
                  >O</span
                >
              </div>
            </div>

            <!-- Botón de Microsoft -->
            <button
              type="button"
              class="app-btn app-btn--secondary app-btn--center w-full"
              (click)="loginWithMicrosoft($event)"
              [disabled]="isMicrosoftLoginLoading || isProcessingMicrosoftLogin || isLoading"
            >
              @if (isMicrosoftLoginLoading || isProcessingMicrosoftLogin) {
                <div
                  class="w-4 h-4 border-2 rounded-full animate-spin"
                  style="border-color: #fc415a; border-top-color: transparent"
                ></div>
                <span class="text-[13px] font-medium">Conectando...</span>
              } @else {
                <fa-icon [icon]="faMicrosoft" class="text-xl"></fa-icon>
                <span>Continuar con Microsoft</span>
              }
            </button>
          </form>

          <!-- Footer -->
          <div
            class="mt-12 pt-8 border-t border-gray-200 dark:border-gray-800 text-center text-xs text-gray-500 dark:text-gray-500"
          >
            <div class="flex justify-center gap-4 mt-2">
              <span>·</span>
              <a
                href="https://www.sdi.es/privacidad/"
                class="hover:text-gray-600 dark:hover:text-gray-400"
                >Políticas de Privacidad y Aviso Legal</a
              >
              <span>·</span>
            </div>
            <p>
              &copy; {{ currentYear }} Desarrollado con ♡ por SDi. Todos los derechos reservados.
            </p>
          </div>
        }
      </div>
    </div>
  </div>

  <!-- Forgot password modal -->
  @if (showForgot) {
    <div class="fixed inset-0 z-50 flex items-center justify-center">
      <!-- Backdrop -->
      <button
        type="button"
        class="absolute inset-0 bg-black/40 backdrop-blur-sm"
        (click)="closeForgot()"
        aria-label="Cerrar modal"
      >
        <span class="sr-only">Cerrar modal</span>
      </button>

      <!-- Modal -->
      <div class="relative w-full max-w-lg mx-4">
        <div
          class="rounded-2xl bg-white dark:bg-gray-900 shadow-2xl border border-gray-200 dark:border-gray-800 overflow-hidden"
        >
          <!-- Close -->
          <button
            type="button"
            class="absolute right-4 top-4 text-gray-400 hover:text-gray-600 dark:text-gray-500 dark:hover:text-gray-300"
            (click)="closeForgot()"
            aria-label="Cerrar"
          >
            ✕
            <span class="sr-only">Cerrar</span>
          </button>

          <div class="p-8">
            <!-- Icon -->
            <div class="flex justify-center mb-4">
              <div
                class="h-12 w-12 rounded-full flex items-center justify-center"
                style="background-color: rgba(252, 65, 90, 0.1)"
              >
                <fa-icon [icon]="faRotateLeft" class="text-xl" style="color: #fc415a"></fa-icon>
              </div>
            </div>

            <!-- Title -->
            <h3 class="text-xl font-semibold text-gray-900 dark:text-white text-center">
              Restablecer contraseña
            </h3>
            <p class="text-sm text-gray-600 dark:text-gray-300 text-center mt-2">
              Introduce tu email para recibir un enlace de recuperación
            </p>

            <!-- Form -->
            <form
              [formGroup]="forgotForm"
              class="mt-6 space-y-4"
              (submit)="$event.preventDefault(); sendForgot()"
            >
              <div>
                <label
                  for="forgotEmail"
                  class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2"
                >
                  Correo electrónico
                </label>
                <input
                  id="forgotEmail"
                  type="email"
                  formControlName="email"
                  placeholder="ejemplo@empresa.com"
                  class="app-input w-full"
                />
                @if (forgotForm.controls.email.touched && forgotForm.controls.email.invalid) {
                  <p class="text-sm text-red-600 dark:text-red-400 mt-2">
                    Introduce un email válido.
                  </p>
                }
              </div>

              <button
                type="button"
                (click)="sendForgot()"
                [disabled]="isSendingForgot"
                class="app-btn app-btn--primary app-btn--center w-full"
              >
                @if (!isSendingForgot) {
                  <span>Enviar enlace</span>
                } @else {
                  <span>Enviando...</span>
                }
              </button>

              <button
                type="button"
                (click)="closeForgot()"
                [disabled]="isSendingForgot"
                class="app-btn app-btn--secondary app-btn--center w-full"
              >
                Cancelar
              </button>

              @if (forgotMessage) {
                <div class="text-sm text-green-700 dark:text-green-300 text-center mt-2">
                  {{ forgotMessage }}
                </div>
              }
            </form>
          </div>
        </div>
      </div>
    </div>
  }
</div>
